export default __webpack_public_path__ + "88c085c7051fc6960e9f48eef433ff59.png";